import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { GeneralResponse, ICountry } from "../../../types/api";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";

export const fetchCountries = async (): Promise<GeneralResponse> => {
  return await Api<any, GeneralResponse<ICountry[]>>({
    method: Methods.GET,
    endpoint: EndPoints.countries,
  });
};

export const useCountriesQuery = () => {
  return useQuery({
    queryKey: ["countries"],
    queryFn: () => fetchCountries(),
    staleTime: 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
  });
};

export const useCountries = () => {
  const {
    data,
    error,
    isLoading,
    isSuccess,
  }: UseQueryResult<GeneralResponse<ICountry[]>> = useCountriesQuery();

  return { data, error, isLoading, isSuccess };
};
